/* eslint-disable react-hooks/exhaustive-deps,arrow-body-style */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./PaymentsContainer.less";
import moment from "moment";
import { Form } from "antd";
import { fetchPaymentsAll } from "../../store/slices/payments";
import Payments from "../../components/Payments/Payments";
import {
  fetchCurrenciesDic,
  fetchPaymentSourceTypes,
  fetchPaymentStatuses,
} from "../../store/slices/rtkDictionaries";
import { agreementsSearchActions } from "../../store/slices/agreementsSearch/agreementsSearch";

const PaymentsContainer = () => {
  const nowDate = moment();
  const pastDate = moment().subtract(30, "days");
  const { paymentsAll, paymentsAllLoading } = useSelector((state) => state.payments);
  const [isLoadData, setIsLoadData] = useState(false);
  const accounts = useSelector((state) => state.accounts);
  const { paymentStatuses } = useSelector((state) => state.rtkDictionaries);
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  // Очистка списка accountSelect при входе и выходе
  useEffect(() => {
    dispatch(agreementsSearchActions.cleanAccounts());
    return () => dispatch(agreementsSearchActions.cleanAccounts());
  }, []);

  const paymentsSearchParams = {
    accountIds: undefined,
    page: 0,
    size: 20,
    datePay: [pastDate, nowDate],
    dateConfirm: [],
    paymentDateFrom: "",
    paymentDateTo: "",
    confirmDateFrom: "",
    confirmDateTo: "",
    "agreement.account.organization.fullNameLikeAny": "",
    "agreement.agreementNumberLikeAny": "",
    unpaged: true,
    includePaymentStatusIds: [2],
    "subscriber.externalId": undefined,
    "organization.property.stringValue": undefined,
  };

  useEffect(() => {
    dispatch(fetchPaymentStatuses());
    dispatch(fetchPaymentSourceTypes());
    dispatch(fetchCurrenciesDic());

    return () => {
      setIsLoadData(false);
    };
  }, []);

  const handleSearchPayments = (values) => {
    setIsLoadData(true);
    // setPageSize({ ...pageSize, page: 0 });
    dispatch(fetchPaymentsAll(values));
  };

  const resetSearchPayments = () => {
    setIsLoadData(false);
    form.setFieldsValue(paymentsSearchParams);
    dispatch(agreementsSearchActions.cleanAccounts());
  };

  return (
    <div className="container_height">
      <Payments
        isLoadData={isLoadData}
        accounts={accounts}
        payments={paymentsAll}
        paymentsLoading={paymentsAllLoading}
        handleSearchPayments={handleSearchPayments}
        resetSearchPayments={resetSearchPayments}
        paymentStatuses={paymentStatuses}
        paymentsSearchParams={paymentsSearchParams}
        form={form}
        // pageSize={pageSize}
      />
    </div>
  );
};

export default PaymentsContainer;
